/** @file Auto-rig panel limits: ghost preview size and opacity, list lengths, confidence bands. */

/**
 * `previewMaxCommands`: autorig.applyPlan re-indexes per command (~4 s per 1,000 commands, commands/autorig), so larger
 * plans get no ghost. Bands: below `low` is low (stack plans are capped at 0.3, mirror fixes at 0.4), below `high` medium.
 */
export const AUTORIG_LIMITS = { previewMaxCommands: 500, ghostOpacity: 0.55, listMax: 50, low: 0.45, high: 0.7 } as const;
